 /*=========================================================================================
  File Name: mutations.js
  Description: POS Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS Module
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment'

export default {

    ADD_TO_CART_STATE(state, payload) {
        state.cart.push(payload);
    },

    SET_PRODUCTS_STATE ( state, payload ) {
        state.products = payload;
    },

    SET_TAXES_STATE ( state, payload ) {
        state.taxes = payload
    },

    SET_CATEGORIES_STATE ( state, payload ) {
        state.categories = payload;
    },
 

    SET_CURRENTORDERS_STATE( state, payload ) {
        state.orders = payload;
    },

    SET_CURRENT_WAITING_TIME_STATE( state, payload ) {
        state.currentWaitingTime = payload;
    },

    SET_ORDER_MANAGER_STATE(state, payload) {
        state.orderManagerState.capacity = payload.capacity;
        state.orderManagerState.currentWaitingTime = payload.currentWaitingTime;
        state.orderManagerState.minWaitingTime = payload.minWaitingTime;
        state.orderManagerState.maxWaitingTime = payload.maxWaitingTime;
        state.orderManagerState.cannotOrderNow = payload.cannotOrderNow;
        state.orderManagerState.increaseTimeStep = payload.increaseTimeStep;
        state.orderManagerState.pendingOrdersIncreaseStep = payload.pendingOrdersIncreaseStep;
        state.orderManagerState.initTimeOfOrder = payload.initTimeOfOrder;
        state.orderManagerState.offTime = moment(payload.offTime, 'HH:mm');
        state.orderManagerState.isEnabled = payload.isEnabled;
      }
}